import React from "react";
import "./Button.scss";
import { Link } from "react-router-dom";

const LinkRoute = ({
  children, // Content to be displayed inside the link
  to = "/", // Target route path
  variant = "primary", // Button style variant (primary, secondary, etc.)
  size = "md", // Size of the button (sm, md, lg)
  className = "", // Additional CSS classes
  ...props // Additional props to be spread on the Link component
}) => {
  /* === Class Name Generation === */
  const prenetClasses = `borderWrapper button-parent`;
  const classes = `button linkButton borderInner ${variant} ${size} ${className}`;
  /* === End Class Name Generation === */

  return (
    <div className={prenetClasses}>
      <Link className={classes} to={to} {...props}>
        {children}
      </Link>
    </div>
  );
};

export default LinkRoute;
